import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersComponent } from './users.component';
import { FormsModule } from '@angular/forms';
import { AppSharedElementsModule } from '../../app-shared-elements/app-shared-elements.module';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ChangePasswordBlockComponent } from '../../app-shared-elements/change-password-block/change-password-block.component';
import { DisabledAutoFillDirective } from '../../app-shared-elements/_directives/disabled-auto-fill.directive';

@NgModule({
    declarations: [UsersComponent],
    imports: [CommonModule, FormsModule, AppSharedElementsModule, NgxDropzoneModule, ChangePasswordBlockComponent, DisabledAutoFillDirective],
    providers: [
        // UsersService
    ],
})
export class UsersModule {}
